import { useContext, useEffect, useState } from 'react';
import { APIContext } from '../Contexts/APIContext';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';

interface Notification {
    id: string;
    title: string;
    text: string;
    url?: string;
}

export const MyNotifications = () => {
    const { get } = useContext(APIContext);
    const [notifications, setNotifications] = useState<Notification[]>([]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        get(`Notification`, `GetMyNotifications`, setNotifications);
    }

    const dismissNotification = (id: string) => async () => {
        get(`Notification`, `DismissNotification?notificationId=${id}`, () => {
            setNotifications(current => current.filter(notification => notification.id !== id));
        });
    };

    return (
        <Stack spacing={2}>
            {notifications.length == 0 &&
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="body2" sx={{ mt: 1 }}>No current notifications</Typography>
                    </CardContent>
                </Card>
            }
            {notifications.map((n) => (
                <Card key={n.id} variant="outlined">
                    <CardContent>
                        {n.title && <Typography variant="h6">{n.title}</Typography>}
                        <Typography variant="body2" sx={{ mt: 1 }}>{n.text}</Typography>
                    </CardContent>
                    <CardActions>
                        <Button color="secondary" variant="outlined" onClick={dismissNotification(n.id)}>Dismiss</Button>
                        {n.url && <Button href={n.url} target="_blank" variant="outlined">Open Link</Button>}
                    </CardActions>
                </Card>
            ))}
        </Stack>
    );
};
